export const T = {
  en_GB: {
    noProductTypesConfigured: "No product types configured for this collection.",
    previousAnswerFound: "Previous Answer Found",
    youAnsweredOn: "You answered this question on",
    usePreviousAnswer: "Use Previous Answer",
    applying: "Applying...",
    startFresh: "Start Fresh",
    incompleteMessage:
      "Complete every product type — declare your experience or finish its assessment.",
    // repNoteViaMember is a template filled by `fillRepresentativeTemplate` (@repo/shared).
    repNote: (name: string) =>
      `Knowledge and experience is collected for ${name}, who acts on behalf of the client — not for the client itself.`,
    repNoteViaMember:
      "Knowledge and experience is collected for {name} ({role}), on behalf of {member}, who acts for the group — not for the group itself.",
    // The locale this table is for — the member lines format "{rep} ({role})" with it.
    locale: "en_GB",
    repGeneric: "the client's representative",
    reuseNoLongerAvailable: "Reuse is no longer available.",
    verdictPassed: "Suitable",
    verdictFailed: "Not suitable",
    verdictIncomplete: "Incomplete",
    notSuitableWarning: "Products in your portfolio require this category to pass.",
    notSuitableWarningMembers: (names: string) =>
      `Products in your portfolio require this category to pass. ${names} did not pass.`,
    quizStartFailed: "Could not start the quiz. Please try again.",
    declareFailed: "Could not save your answer. Please try again.",
    // QL-653 — a product type some, but not all, answering lines have completed.
    typeCompletedCount: (completed: number, total: number) => `${completed} of ${total} completed`,
    repListNote:
      "Representatives: several people act for this client and each answers knowledge and experience for themselves. A product type counts only when all of them pass.",
  },
  nb_NO: {
    noProductTypesConfigured: "Ingen produkttyper konfigurert for denne samlingen.",
    previousAnswerFound: "Tidligere svar funnet",
    youAnsweredOn: "Du besvarte dette spørsmålet den",
    usePreviousAnswer: "Bruk tidligere svar",
    applying: "Bruker...",
    startFresh: "Start på nytt",
    incompleteMessage: "Fullfør hver produkttype — angi din erfaring eller fullfør vurderingen.",
    repNote: (name: string) =>
      `Kunnskap og erfaring registreres for ${name}, som handler på vegne av kunden — ikke for kunden selv.`,
    repNoteViaMember:
      "Kunnskap og erfaring registreres for {name} ({role}), på vegne av {member}, som handler for gruppen — ikke for gruppen selv.",
    locale: "nb_NO",
    repGeneric: "kundens representant",
    reuseNoLongerAvailable: "Gjenbruk er ikke lenger tilgjengelig.",
    verdictPassed: "Egnet",
    verdictFailed: "Ikke egnet",
    verdictIncomplete: "Ufullstendig",
    notSuitableWarning: "Produkter i porteføljen krever at denne kategorien bestås.",
    notSuitableWarningMembers: (names: string) =>
      `Produkter i porteføljen krever at denne kategorien bestås. ${names} besto ikke.`,
    quizStartFailed: "Kunne ikke starte quizen. Prøv igjen.",
    declareFailed: "Kunne ikke lagre svaret ditt. Prøv igjen.",
    typeCompletedCount: (completed: number, total: number) => `${completed} av ${total} fullført`,
    repListNote:
      "Representanter: flere personer handler for denne kunden, og hver av dem svarer på kunnskap og erfaring for seg selv. En produkttype teller bare når alle har bestått.",
  },
} as const;
